// IMPORTANT: Note that with Redux, state should NEVER be changed.
import objectAssign from 'object-assign';
import { usersInitialState } from '../store/initialState';
import { clone } from './helper';
import { combineReducers } from 'redux';
import { sortMyRoles, sortInvitedRoles } from 'businessLogic/sorting';
import _ from 'lodash';
import {
  DO_USER_LOGIN,
  USER_LOGIN_PROCESS_FINISHED,
  USER_IS_LOGGED_IN,
  USER_IS_LOGGED_OUT,
  LOGIN_FAILED,
  USER_EMAIL_CHANGED,
  USER_PASSWORD_RESET,
  USER_PASSWORD_RESETTED,
  USER_PASSWORD_RESET_FAILED,
  SET_RESET_PASSWORD_TOKEN,
  USER_FORGOT_PASSWORD_FORM_RESET,
  RESET_PASSWORD_TOKEN_FORM,
  SET_CHANGE_PASSWORD_FORM,
  SET_RESET_PASSWORD_FORM,
  UPDATE_USER_PROFILE_NEW_EMAIL,
  LOGIN_SUCCESS,
  GET_USER_PROFILE,
  GOT_USER_PROFILE,
  RESET_USER_PROFILE,
  GET_USER_BASIC_PROFILE,
  GOT_USER_BASIC_PROFILE,
  ERROR_GETTING_USER_BASIC_PROFILE,
  GET_TIMEZONES,
  GOT_TIMEZONES,
  TYPING_USER_PROFILE,
  SAVE_USER,
  SAVED_USER,
  CHANGE_USER_IMAGE,
  SET_PROFILE_IMAGE_DROPPED,
  IGNORE_RELOAD_USER_IMAGE,
  RESET_IMAGE,
  RESET_IMAGE_TO_DEFAULT,
  GET_NOT_ME_USER_PROFILE,
  GOT_NOT_ME_USER_PROFILE,
  USER_CALL_STATUS_CHANGED,
  GOT_WAITING_AREA_USERS,
  SEARCH_SELECT_USERS_FORM,
  SET_WA_USER_SIGNUP_FORM,
  RESET_WA_USER_SIGNUP_FORM,
  GOT_MY_ROLES,
  GOT_ORGANISATIONAL_UNIT_USERS,
  UNDO_REMOVE_ROLE,
  REMOVE_ROLE,
  RESET_MY_ROLES,
  UNDO_REMOVE_ALL_ROLE,
  REMOVE_ALL_ROLE,
  GOT_MEETING_ROOM_USERS,
  GOT_ALL_USERS_FOR_ADMIN,
  UPDATE_SINGLE_USERS_FOR_ADMIN,
  UPDATE_SELECTED_USER_FOR_ALL_USERS,
  UPDATE_CURRENT_ACTIVE_PAGENO_FOR_ALL_USERS,
  UPDATE_ALL_USERS_SEARCH_BAR,
  RESET_ALL_USERS_SEARCH_FROM,
  UPDATE_ALL_USERS_SEARCH_FROM,
  UPDATE_HAS_ROLES_IN_OTHER_NETWORKS,
  GOT_USER_INVITATIONS,
  CLEAR_USER_INVITATION_FORM,
  INTEND_TO_REMOVE_INVITED_ROLE,
  UNDO_REMOVE_INVITED_ROLE,
  REMOVE_ALL_INVITED_ROLES,
  UNDO_REMOVE_ALL_INVITED_ROLES,
  GOT_USER_CALLS_DETAILS,
} from '../actions/user.js';

const updateUserProfileWithDirectlyWA = (userProfile) => {
  let shouldLoadDirectlyAssociatedWAs = userProfile.shouldLoadDirectlyAssociatedWAs;

  if (shouldLoadDirectlyAssociatedWAs) {
    let waitingAreasDirectlyAssociated = userProfile.waitingAreas.filter(
      (waitingArea) => waitingArea.hasDirectAssociation === true
    );

    userProfile.waitingAreasDirectlyAssociated = waitingAreasDirectlyAssociated;
    userProfile.hasDirectlyAssociatedWaitingAreas =
      waitingAreasDirectlyAssociated && waitingAreasDirectlyAssociated.length > 0;
  }

  return userProfile;
};

const reducer = (state = usersInitialState, action) => {
  let userProfile = {};

  switch (action.type) {
    case DO_USER_LOGIN:
      return objectAssign({}, state, { fetchingLogin: true });
    case USER_LOGIN_PROCESS_FINISHED:
      return objectAssign({}, state, {
        loggedIn: true,
        fetchingLogin: false,
      });
    case LOGIN_SUCCESS:
      return objectAssign({}, state, {
        fetchingLogin: false,
        fetchingUserProfileAfterLogin: true, //now we will start fetching the user details, so this is true
      });
    case USER_FORGOT_PASSWORD_FORM_RESET:
      return objectAssign({}, state, {
        userEmailForPasswordReset: '',
        passwordResetRequestCompleted: false,
      });
    case USER_PASSWORD_RESET:
      return objectAssign({}, state, {
        resetingPassword: true,
        passwordResetRequestCompleted: false,
      });
    case USER_PASSWORD_RESETTED:
      return objectAssign({}, state, {
        resetingPassword: false,
        passwordResetRequestCompleted: true,
      });
    case USER_EMAIL_CHANGED:
      return objectAssign({}, state, {
        userEmailForPasswordReset: action.data,
      });
    case LOGIN_FAILED:
      return objectAssign({}, state, { fetchingLogin: false });
    case USER_IS_LOGGED_IN:
      return objectAssign({}, state, { loggedIn: true });
    case USER_IS_LOGGED_OUT:
      return objectAssign({}, state, { loggedIn: false });
    case USER_PASSWORD_RESET_FAILED:
      return objectAssign({}, state, {
        resetingPassword: false,
        passwordResetRequestCompleted: false,
      });
    //------------------RESET PASSWORD VIA TOKEN---------------------------//
    case RESET_PASSWORD_TOKEN_FORM:
      return objectAssign({}, state, { resetPassword: {} });
    case SET_RESET_PASSWORD_FORM:
      return objectAssign({}, state, { resetPassword: action.data });
    case SET_RESET_PASSWORD_TOKEN:
      var copy = clone(state);
      copy.resetPassword = {};
      copy.resetPassword.resetPasswordToken = action.data.resetPasswordToken;
      copy.resetPassword.resetToken = action.data.resetToken;
      return objectAssign({}, state, { resetPassword: copy.resetPassword });
    //------------------END RESET PASSWORD VIA TOKEN---------------------------//
    case UPDATE_USER_PROFILE_NEW_EMAIL:
      return objectAssign({}, state, { newEmail: action.data });

    //--------------------------CHANGE PASSWORD---------------------
    case SET_CHANGE_PASSWORD_FORM:
      return objectAssign({}, state, { changePassword: action.data });
    //--------------------------END CHANGE PASSWORD---------------------

    //--------------------------CHANGE PASSWORD---------------------

    //---------------------Create user ACcount----------------------------
    case SET_WA_USER_SIGNUP_FORM:
      return objectAssign({}, state, { userSignupCreateForm: action.data });
    case RESET_WA_USER_SIGNUP_FORM:
      return objectAssign({}, state, { userSignupCreateForm: {} });

    //---------------------End Create user Account ---------------------
    case GET_USER_PROFILE:
      return objectAssign({}, state, {
        fetchingUserProfile: true,
        isDirty: false,
      });
    case GOT_USER_PROFILE: {
      userProfile = updateUserProfileWithDirectlyWA(action.data);

      userProfile.displayNameInHeader = userProfile.firstName + ' ' + userProfile.lastName;
      return objectAssign({}, state, {
        fetchingUserProfile: false,
        userProfile,
        isProfileImageEditable: false,
        membershipAndRoles: action.data.membershipAndRoles,
        isDirty: false,
      });
    }
    case RESET_USER_PROFILE:
      return objectAssign({}, state, {
        fetchingUserProfile: true,
        isDirty: false,
        userProfile: {},
      });

    case GET_USER_BASIC_PROFILE:
      return objectAssign({}, state, { fetchingUserProfile: true });
    case ERROR_GETTING_USER_BASIC_PROFILE:
      return objectAssign({}, state, { fetchingUserProfileAfterLogin: false });
    case USER_CALL_STATUS_CHANGED:
      return objectAssign({}, state, { isInCall: action.data });
    case GOT_USER_BASIC_PROFILE:
      userProfile = updateUserProfileWithDirectlyWA(action.data);
      userProfile.displayNameInHeader = userProfile.firstName + ' ' + userProfile.lastName;

      return objectAssign({}, state, {
        fetchingUserProfileAfterLogin: false,
        fetchingUserProfile: false,
        userProfile,
        isProfileImageEditable: false,
        userHasMeetingRooms: action.data.hasMeetingRooms,
        userHasOrganisations: action.data.hasOrganisations,
        userHasWaitingAreas: action.data.hasWaitingAreas,
        isInCall: action.data.isInCall,
        isInGCCall: action.data.isInGCCall,
        isConsultNowFeatureEnabled: action.data.isConsultNowFeatureEnabled,
        isDirty: false,
        isGroupConsultationFeatureEnabled: action.data.isGroupConsultationFeatureEnabled,
        isRecordingFeatureEnabled: action.data.isRecordingFeatureEnabled,
      });
    case GET_TIMEZONES:
      return objectAssign({}, state, { fetchingTimezones: true });
    case GET_NOT_ME_USER_PROFILE:
      var copy = clone(state);
      var personWhomIamGettingData = action.data;
      var dynamicFetchingPersonId = 'fetchingPersonWithId' + personWhomIamGettingData;
      let modifiedObject = {};
      copy.waitingAreaParticipants[dynamicFetchingPersonId] = true;

      return objectAssign({}, state, copy);
    case GOT_NOT_ME_USER_PROFILE:
      var copy = clone(state);
      var personWhomIamGettingData = action.data.id;
      var dynamicFetchingPersonId = 'fetchingPersonWithId' + personWhomIamGettingData;
      var dynamicStateProperty = 'personWithId' + personWhomIamGettingData;
      copy.waitingAreaParticipants[dynamicFetchingPersonId] = false;

      copy.waitingAreaParticipants[dynamicStateProperty] = action.data;
      return objectAssign({}, state, copy);
    case GOT_TIMEZONES:
      return objectAssign({}, state, {
        fetchingTimezones: false,
        timezones: action.data,
      });
    case TYPING_USER_PROFILE:
      return objectAssign({}, state, {
        userProfile: updateUserProfileWithDirectlyWA(action.data),
        isDirty: true,
      });
    case SAVE_USER:
      return objectAssign({}, state, { savingUserProfile: action.data });
    case SAVED_USER:
      userProfile = Object.assign({}, state.userProfile, {
        userImageUrl: action.data.userImageUrl,
        displayNameInHeader: action.data.firstName + ' ' + action.data.lastName,
      });
      return objectAssign({}, state, {
        isDirty: false,
        savingUserProfile: false,
        isProfileImageEditable: false,
        userProfile: userProfile,
      });
    case CHANGE_USER_IMAGE:
      userProfile = Object.assign({}, state.userProfile, {
        userImageBase64: action.file,
        userImageFileName: action.name,
      });
      return Object.assign({}, state, { userProfile });
    case IGNORE_RELOAD_USER_IMAGE:
      return Object.assign({}, state, { isProfileImageEditable: true });
    case SET_PROFILE_IMAGE_DROPPED:
      return objectAssign({}, state, {
        profileImageDropped: action.data,
        isProfileImageEditable: true,
        isDirty: true,
      });
    case RESET_IMAGE:
      userProfile = Object.assign({}, state.userProfile, {
        userImageBase64: null,
        userImageFileName: null,
      });
      return Object.assign({}, state, {
        userProfile: userProfile,
        profileImageDropped: undefined,
        isProfileImageEditable: false,
      });
    case RESET_IMAGE_TO_DEFAULT:
      userProfile = Object.assign({}, state.userProfile, {
        userImageBase64: null,
        userImageFileName: null,
        userImageUrl: null,
      });
      return Object.assign({}, state, {
        userProfile: userProfile,
        profileImageDropped: undefined,
        isProfileImageEditable: false,
      });

    case GOT_WAITING_AREA_USERS: {
      return objectAssign({}, state, { usersIcanManage: action.data.users });
    }
    case GOT_ORGANISATIONAL_UNIT_USERS: {
      //the function updates the usersICanManage list by reference
      return objectAssign({}, state, {
        usersIcanManage: action.data.organisationUsers.users,
      });
    }
    case SEARCH_SELECT_USERS_FORM.LOADING_SUGGESTIONS: {
      const searchSelectUsersForm = objectAssign({}, state.searchSelectUsersForm, {
        isLoading: true,
        searchTerm: action.data,
      });
      return objectAssign({}, state, {
        searchSelectUsersForm: searchSelectUsersForm,
      });
    }
    case SEARCH_SELECT_USERS_FORM.SHOW_SUGGESTIONS: {
      if (state.searchSelectUsersForm.searchTerm.includes(action.data.searchTerm)) {
        // show suggestions if they still match the current search term, fix for https://jira.attendanywhere.com/browse/VCM-5113
        const newSearchSelectUsersForm = objectAssign({}, state.searchSelectUsersForm, {
          searchResults: action.data.searchSuggestions,
          isLoading: false,
        });
        return objectAssign({}, state, {
          searchSelectUsersForm: newSearchSelectUsersForm,
        });
      } else {
        const newSearchSelectUsersForm = objectAssign({}, state.searchSelectUsersForm, {
          searchResults: [],
          isLoading: false,
        });
        return objectAssign({}, state, {
          searchSelectUsersForm: newSearchSelectUsersForm,
        });
      }
    }
    case SEARCH_SELECT_USERS_FORM.CLEAR_SUGGESTIONS: {
      const newSearchSelectUsersForm = objectAssign({}, state.searchSelectUsersForm, {
        searchResults: [],
        isLoading: false,
        searchTerm: '',
      });
      return objectAssign({}, state, {
        searchSelectUsersForm: newSearchSelectUsersForm,
      });
    }
    case SEARCH_SELECT_USERS_FORM.SELECT_USER: {
      // if user is already selected, no action required, hence return current state
      if (
        state.searchSelectUsersForm.selectedUsers.find(
          (user) => user.email.toLowerCase() === action.data.email.toLowerCase()
        )
      )
        return state;

      // add this user to selected users
      const newSearchSelectUsersForm = objectAssign({}, state.searchSelectUsersForm, {
        selectedUsers: [...state.searchSelectUsersForm.selectedUsers, action.data],
      });
      return objectAssign({}, state, {
        searchSelectUsersForm: newSearchSelectUsersForm,
      });
    }
    case SEARCH_SELECT_USERS_FORM.SELECT_SINGLE_USER: {
      // if user is already selected, no action required, hence return current state
      if (
        state.searchSelectUsersForm.selectedUsers.find(
          (user) => user.email.toLowerCase() === action.data.email.toLowerCase()
        )
      )
        return state;

      // replace exiting user(s) with this user
      const newSearchSelectUsersForm = objectAssign({}, state.searchSelectUsersForm, {
        selectedUsers: [action.data],
        isLoading: false,
        searchTerm: action.data.email,
        searchResults: [],
      });
      return objectAssign({}, state, {
        searchSelectUsersForm: newSearchSelectUsersForm,
      });
    }
    case SEARCH_SELECT_USERS_FORM.UNSELECT_USER: {
      const newSearchSelectUsersForm = objectAssign({}, state.searchSelectUsersForm, {
        selectedUsers: state.searchSelectUsersForm.selectedUsers.filter(
          (user) => user.email.toLowerCase() !== action.data.email.toLowerCase()
        ),
      });
      return objectAssign({}, state, {
        searchSelectUsersForm: newSearchSelectUsersForm,
      });
    }
    case SEARCH_SELECT_USERS_FORM.CLEAR_FORM: {
      return objectAssign({}, state, {
        searchSelectUsersForm: usersInitialState.searchSelectUsersForm,
      });
    }
    case GOT_MY_ROLES: {
      // Although it is called "myRoles", it can contain other user's roles for another dialog
      let myRoles = sortMyRoles(action.data);
      return objectAssign({}, state, { myRoles: myRoles });
    }

    case RESET_MY_ROLES: {
      let myRoles = sortMyRoles(action.data);
      return objectAssign({}, state, { myRoles: usersInitialState.myRoles });
    }

    case REMOVE_ROLE: {
      let myRoles = clone(state.myRoles);
      if (myRoles.length > 0) {
        let toRemoveRole = myRoles.find((item) => item.personNetworkRoleId == action.data);
        if (toRemoveRole) {
          toRemoveRole.isDeleted = true;
        }
      }
      return objectAssign({}, state, { myRoles });
    }
    case UNDO_REMOVE_ROLE: {
      let myRoles = clone(state.myRoles);
      if (myRoles.length > 0) {
        let undoRemoveRole = myRoles.find((item) => item.personNetworkRoleId == action.data);
        if (undoRemoveRole) {
          undoRemoveRole.isDeleted = false;
        }
      }
      return objectAssign({}, state, { myRoles });
    }
    case UNDO_REMOVE_ALL_ROLE: {
      let myRoles = clone(state.myRoles);
      if (myRoles.length > 0) {
        myRoles.map((item) => {
          item.isDeleted = false;
        });
      }
      return objectAssign({}, state, { myRoles });
    }

    case REMOVE_ALL_ROLE: {
      let myRoles = clone(state.myRoles);
      if (myRoles.length > 0) {
        myRoles.map((item) => {
          item.isDeleted = true;
        });
      }
      return objectAssign({}, state, { myRoles });
    }
    // Meeting room manage users
    case GOT_MEETING_ROOM_USERS:
      return objectAssign({}, state, {
        usersIcanManage: action.data.meetingRoomUsers.users,
      });
    // Manage All Users Page
    case GOT_ALL_USERS_FOR_ADMIN: {
      let currentUsersIcanManage = clone(state.usersIcanManageForAdmin);
      let filteredUsersIcanManage = currentUsersIcanManage.filter((existRecord) => {
        return !action.data.users.some((newUser) => {
          return newUser.personId == existRecord.personId;
        });
      });

      let usersIcanManageForAdminNew = [...filteredUsersIcanManage, ...action.data.users];
      let totalRows = parseInt(action.data.totalRows, 10);
      let newAllUsersSearchForm =
        // If fetch users list for all users I can manage, then needs to update total number of users that I can manage
        state.allUsersSearchForm.searchString == ''
          ? {
              ...state.allUsersSearchForm,
              totalRowsForSet: totalRows || 0,
              numberOfAllUsers: totalRows || 0,
            }
          : {
              ...state.allUsersSearchForm,
              totalRowsForSet: totalRows,
            };
      return objectAssign({}, state, {
        usersIcanManageForAdmin: usersIcanManageForAdminNew,
        allUsersSearchForm: newAllUsersSearchForm,
      });
    }
    case UPDATE_SINGLE_USERS_FOR_ADMIN: {
      let usersIcanManageForAdminNew = clone(state.usersIcanManageForAdmin);
      let newAllUsersSearchForm = clone(state.allUsersSearchForm);
      let updateNumberOfAllUsers = newAllUsersSearchForm.numberOfAllUsers;
      let updateTotalRowsForSet = newAllUsersSearchForm.totalRowsForSet;
      let userIndex = usersIcanManageForAdminNew.findIndex((user) => user.personId == action.data.personId);
      if (userIndex != undefined && userIndex > -1) {
        if (!!action.data.userStatus) {
          usersIcanManageForAdminNew[userIndex] = action.data.userStatus;
        } else {
          usersIcanManageForAdminNew.splice(userIndex, 1);
          updateNumberOfAllUsers = newAllUsersSearchForm.numberOfAllUsers - 1;
          updateTotalRowsForSet = newAllUsersSearchForm.totalRowsForSet - 1;
        }
      }
      let updatedAllUsersSearchForm = {
        ...newAllUsersSearchForm,
        numberOfAllUsers: updateNumberOfAllUsers,
        totalRowsForSet: updateTotalRowsForSet,
      };
      return objectAssign({}, state, {
        usersIcanManageForAdmin: usersIcanManageForAdminNew,
        allUsersSearchForm: updatedAllUsersSearchForm,
      });
    }
    case UPDATE_SELECTED_USER_FOR_ALL_USERS: {
      return Object.assign({}, state, {
        selectedUserInAllUsersPage: action.data,
      });
    }
    case UPDATE_CURRENT_ACTIVE_PAGENO_FOR_ALL_USERS: {
      let allUsersSearchForm = clone(state.allUsersSearchForm);
      let newAllUsersSearchForm = {
        ...allUsersSearchForm,
        currentActivePageNo: parseInt(allUsersSearchForm.currentActivePageNo, 10) + parseInt(action.data, 10),
      };
      return Object.assign({}, state, {
        allUsersSearchForm: newAllUsersSearchForm,
      });
    }
    case UPDATE_ALL_USERS_SEARCH_BAR: {
      return objectAssign({}, state, {
        currentAllUsersSearchFilter: action.data.searchString || '',
        currentAllUsersIsFormSubmitted: action.data.isFormSubmitted || false,
      });
    }
    case RESET_ALL_USERS_SEARCH_FROM: {
      let allUsersSearchForm = clone(state.allUsersSearchForm);
      let currentNumberOfAllUsers = allUsersSearchForm.numberOfAllUsers || 0;
      let resetAllUsersSearchForm = {
        ...usersInitialState.allUsersSearchForm,
        numberOfAllUsers: currentNumberOfAllUsers,
      };
      return objectAssign({}, state, {
        usersIcanManageForAdmin: usersInitialState.usersIcanManageForAdmin,
        allUsersSearchForm: resetAllUsersSearchForm,
      });
    }
    case UPDATE_ALL_USERS_SEARCH_FROM: {
      let allUsersSearchForm = clone(state.allUsersSearchForm);
      let newAllUsersSearchForm = {
        ...allUsersSearchForm,
        ...action.data,
      };
      return objectAssign({}, state, {
        allUsersSearchForm: newAllUsersSearchForm,
      });
    }
    case UPDATE_HAS_ROLES_IN_OTHER_NETWORKS: {
      return objectAssign({}, state, { hasRolesInOtherNetworks: action.data });
    }
    // Got user invitations
    case GOT_USER_INVITATIONS:
      return objectAssign({}, state, {
        selectedUserInvitationForm: {
          roles: sortInvitedRoles(action.data.roles),
          hasRolesInOtherNetworks: action.data.hasRolesInOtherNetworks,
        },
      });

    case CLEAR_USER_INVITATION_FORM:
      return objectAssign({}, state, {
        selectedUserInvitationForm: {},
      });

    case INTEND_TO_REMOVE_INVITED_ROLE: {
      let selectedUserInvitationForm = clone(state.selectedUserInvitationForm);
      let myInvitations = selectedUserInvitationForm.roles;

      if (myInvitations.length > 0) {
        let toRemoveInvitation = myInvitations.find((item) => {
          return item.personNetworkRoleId == action.data;
        });

        if (toRemoveInvitation) {
          toRemoveInvitation.isDeleted = true;
        }
      }

      return objectAssign({}, state, {
        selectedUserInvitationForm: {
          roles: myInvitations,
          hasRolesInOtherNetworks: selectedUserInvitationForm.hasRolesInOtherNetworks,
        },
      });
    }

    case UNDO_REMOVE_INVITED_ROLE: {
      let selectedUserInvitationForm = clone(state.selectedUserInvitationForm);
      let myInvitations = selectedUserInvitationForm.roles;

      if (myInvitations.length > 0) {
        let toRemoveInvitation = myInvitations.find((item) => {
          return item.personNetworkRoleId == action.data;
        });

        if (toRemoveInvitation) {
          toRemoveInvitation.isDeleted = false;
        }
      }
      return objectAssign({}, state, {
        selectedUserInvitationForm: {
          roles: myInvitations,
          hasRolesInOtherNetworks: selectedUserInvitationForm.hasRolesInOtherNetworks,
        },
      });
    }
    case REMOVE_ALL_INVITED_ROLES: {
      let selectedUserInvitationForm = clone(state.selectedUserInvitationForm);
      let invitedRoles = selectedUserInvitationForm.roles;
      if (invitedRoles.length > 0) {
        invitedRoles.map((item) => {
          item.isDeleted = true;
        });
      }
      return objectAssign({}, state, {
        selectedUserInvitationForm: {
          roles: invitedRoles,
          hasRolesInOtherNetworks: selectedUserInvitationForm.hasRolesInOtherNetworks,
        },
      });
    }
    case UNDO_REMOVE_ALL_INVITED_ROLES: {
      let selectedUserInvitationForm = clone(state.selectedUserInvitationForm);
      let invitedRoles = selectedUserInvitationForm.roles;
      if (invitedRoles.length > 0) {
        invitedRoles.map((item) => {
          item.isDeleted = false;
        });
      }
      return objectAssign({}, state, {
        selectedUserInvitationForm: {
          roles: invitedRoles,
          hasRolesInOtherNetworks: selectedUserInvitationForm.hasRolesInOtherNetworks,
        },
      });
    }

    case GOT_USER_CALLS_DETAILS: {
      return Object.assign({}, state, {
        userCallsDetails: action.data,
      });
    }

    default:
      return state;
  }
};

export default reducer;
